import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PushHistoryApi } from 'api';
import type { PushHistory } from 'api/methods/PushHistoryApi';

/**
 * [PushHistory] Query key 생성
 * --
 */
export const pushHistoryQueryKeys = createQueryKeys('pushHistory', {
  getPushHistory: (
    idx: number,
    params?: { [key: string]: string | number }
  ) => [idx, params],
  getPushHistories: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [PushHistory] 푸시 알림 내역 전체 조회
 * --
 */
export const useGetPushHistories = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: pushHistoryQueryKeys.getPushHistories(params).queryKey,
    queryFn: () => PushHistoryApi.getPushHistories(params),
    ...options,
  });
  return data;
};

/**
 * [PushHistory] 푸시 알림 내역 상세 조회
 * --
 */
export const useGetPushHistory = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: pushHistoryQueryKeys.getPushHistory(idx, params).queryKey,
    queryFn: () => PushHistoryApi.getPushHistory(idx, params),
  });

  return data;
};

/**
 * [PushHistory] 푸시 알림 내역 생성
 * --
 */
export const useCreatePushHistory = (body: PushHistory) => {
  const { mutateAsync: createPushHistory, ...result } = useMutation({
    mutationFn: (variables: PushHistory) =>
      PushHistoryApi.createPushHistory(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createPushHistory, ...result };
};

/**
 * [PushHistory] 푸시 알림 내역 수정
 * --
 */
export const useUpdatePushHistory = (body: PushHistory) => {
  const { mutateAsync: updatePushHistory, ...result } = useMutation({
    mutationFn: (variables: PushHistory) =>
      PushHistoryApi.updatePushHistory(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updatePushHistory, ...result };
};

/**
 * [PushHistory] 푸시 알림 내역 삭제
 * --
 */
export const useDeletePushHistory = (idx: number) => {
  const { mutateAsync: deletePushHistory, ...result } = useMutation({
    mutationFn: (variables: number) =>
      PushHistoryApi.deletePushHistory(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deletePushHistory, ...result };
};
